import Vue from "vue";
import {
  Container,
  Aside,
  Header,
  Main,
  Input,
  InputNumber,
  Button,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Table,
  TableColumn,
  Select,
  Option,
  Pagination,
  DatePicker,
  Form,
  FormItem,
  Row,
  Col,
  Checkbox,
  CheckboxGroup,
  Tree,
  Radio,
  RadioGroup,
  Tooltip,
  Alert,
  Card,
  Dialog,
  Switch,
  Upload,
  Popover,
  Steps,
  Step,
  Progress,
  Tag,
  Tabs,
  TabPane,
  Collapse,
  CollapseItem,
  OptionGroup,
  Cascader,
  Loading,
  Link,
  RadioButton,
  Empty,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Badge,
  Image
} from "element-ui";

import DFloater from "@/components/DFloater.vue";
import DContainerLayout from "@/views/components/DContainerLayout.vue";
import DItemSelector from "@/components/DItemSelector.vue";

export default function () {
  Vue.component(Container.name, Container);
  Vue.component(Header.name, Header);
  Vue.component(Aside.name, Aside);
  Vue.component(Main.name, Main);
  Vue.component(Input.name, Input);
  Vue.component(InputNumber.name, InputNumber);
  Vue.component(Button.name, Button);
  Vue.component(Menu.name, Menu);
  Vue.component(MenuItem.name, MenuItem);
  Vue.component(MenuItemGroup.name, MenuItemGroup);
  Vue.component(Submenu.name, Submenu);
  Vue.component(Table.name, Table);
  Vue.component(TableColumn.name, TableColumn);
  Vue.component(Select.name, Select);
  Vue.component(Option.name, Option);
  Vue.component(Pagination.name, Pagination);
  Vue.component(DatePicker.name, DatePicker);
  Vue.component(Form.name, Form);
  Vue.component(FormItem.name, FormItem);
  Vue.component(Row.name, Row);
  Vue.component(Col.name, Col);
  Vue.component(Checkbox.name, Checkbox);
  Vue.component(CheckboxGroup.name, CheckboxGroup);
  Vue.component(Tree.name, Tree);
  Vue.component(Radio.name, Radio);
  Vue.component(RadioGroup.name, RadioGroup);
  Vue.component(Tooltip.name, Tooltip);
  Vue.component(Alert.name, Alert);
  Vue.component(Card.name, Card);
  Vue.component(Dialog.name, Dialog);
  Vue.component(Switch.name, Switch);
  Vue.component(Upload.name, Upload);
  Vue.component(Popover.name, Popover);
  Vue.component(Steps.name, Steps);
  Vue.component(Step.name, Step);
  Vue.component(Progress.name, Progress);
  Vue.component(Tag.name, Tag);
  Vue.component(Tabs.name, Tabs);
  Vue.component(TabPane.name, TabPane);
  Vue.component(Collapse.name, Collapse);
  Vue.component(CollapseItem.name, CollapseItem);
  Vue.component(OptionGroup.name, OptionGroup);
  Vue.component(Cascader.name, Cascader);
  Vue.component(RadioButton.name, RadioButton);
  Vue.component(Empty.name, Empty);
  Vue.component(Dropdown.name, Dropdown);
  Vue.component(DropdownItem.name, DropdownItem);
  Vue.component(DropdownMenu.name, DropdownMenu);
  Vue.component(Badge.name, Badge);
  Vue.component(Image.name, Image);

  Vue.component("DFloater", DFloater);
  Vue.component("DContainerLayout", DContainerLayout);
  Vue.component("DItemSelector", DItemSelector);

  Vue.use(Loading);
  Vue.use(Link);
}
